module.exports = __webpack_public_path__ + "img/065.d1652957.jpg";